import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Shield, Lock } from "lucide-react";
import api, { formatApiError } from "../lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#08090B] grid-tactical flex items-center justify-center px-4">
      <div className="clip-corners bg-[#0F1115] border border-white/10 p-10 w-full max-w-md">
        <img src="/images/logo.png" alt="Frontline K9 Security" className="h-14 w-auto mb-2" />
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-gray-500 mb-8">Command Access — Authorized Only</p>

        <form data-testid="admin-login-form" onSubmit={submit} className="flex flex-col gap-4">
          <input
            data-testid="admin-email-input"
            type="email"
            required
            placeholder="Operator email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-[#08090B] border border-white/10 focus:border-blue-500/60 outline-none px-4 py-3 text-sm text-gray-100 placeholder:text-gray-600 transition-colors duration-300"
          />
          <input
            data-testid="admin-password-input"
            type="password"
            required
            placeholder="Passkey"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-[#08090B] border border-white/10 focus:border-blue-500/60 outline-none px-4 py-3 text-sm text-gray-100 placeholder:text-gray-600 transition-colors duration-300"
          />
          {error && (
            <p data-testid="admin-login-error" className="text-blue-400 text-sm font-mono">{error}</p>
          )}
          <button
            data-testid="admin-login-submit-button"
            type="submit"
            disabled={loading}
            className="clip-corners bg-blue-600 hover:bg-blue-500 disabled:opacity-50 text-white font-mono text-sm uppercase tracking-[0.2em] px-8 py-4 flex items-center justify-center gap-3 transition-colors duration-300"
          >
            <Lock className="w-4 h-4" />
            {loading ? "Authenticating..." : "Authenticate"}
          </button>
        </form>

        <Link data-testid="back-to-site-link" to="/" className="block mt-6 text-center font-mono text-xs uppercase tracking-[0.2em] text-gray-600 hover:text-blue-400 transition-colors duration-300">
          ← Return to site
        </Link>
      </div>
    </div>
  );
}
